import React, { PureComponent } from "react";
import styled from "styled-components";
import { cssMainSelector } from "../../../lib/cssSelectors";
import MaterialIcon from "../../MaterialIcon";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Pagination from "../../Pagination";
import { OFFER_TYPES } from "../../../constants/offerTypes";
import { getOfferResultProps } from "../../../lib/offerResultProps";

const Container = styled.div``;

const CollapseLink = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    position: relative;
    text-align: ${p => p.theme.offerResults.collapsibleLinkAlign};
    top: ${p => p.theme.offerResults.collapsibleLinkPositionTop};

    * {
      color: ${p => p.theme.offerResults.collapsibleLinkColor};
      cursor: pointer;
      font-size: ${p => p.theme.offerResults.collapsibleLinkFontSize};
      user-select: none;
    }
  }
`;

const PaginationWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    width: 100%;
  }
`;

class OfferResultsLayout extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      onCollapseClick,
      portalOfferResults,
      totalPages
    } = this.props;
    const collapsibleResults =
      clientConfig.widgetOptions[offerType].collapsibleResults;
    const collapsibleResultsLimit =
      clientConfig.widgetOptions[offerType].collapsibleResultsLimit;
    const pagination = clientConfig.widgetOptions[offerType].pagination;

    return (
      <Container>
        {this.results()}
        {pagination && totalPages > 1 && this.pagination()}
        {!pagination &&
          collapsibleResults &&
          portalOfferResults.length > collapsibleResultsLimit && (
            <CollapseLink onClick={onCollapseClick}>
              {this.collapseText()}
            </CollapseLink>
          )}
      </Container>
    );
  }

  results() {
    const {
      clientConfig,
      collapsed,
      currentPage,
      offerType,
      offerResultComponent,
      portal,
      portalOfferResults,
      updateExperiment,
      updateModal,
      widgetOptions
    } = this.props;
    const collapsibleResults =
      clientConfig.widgetOptions[offerType].collapsibleResults;
    const collapsibleResultsLimit =
      clientConfig.widgetOptions[offerType].collapsibleResultsLimit;
    const pagination = clientConfig.widgetOptions[offerType].pagination;
    const paginationPerPage =
      clientConfig.widgetOptions[offerType].paginationPerPage;
    const maxOfferResultToShow = currentPage * paginationPerPage;
    const minOfferResultToShow = (currentPage - 1) * paginationPerPage + 1;
    let pOfferResults = portalOfferResults;
    let showPerShop = false;

    const offerResults = [];
    const OfferResultComponent = offerResultComponent;
    let i = 0;

    if (offerType === OFFER_TYPES.phoneOffer && pOfferResults.length === 1) {
      const count = pOfferResults[0].shops.length;
      let newOfferResults = [];

      for (let i = 0; i < count; i += 1) {
        let result = getOfferResultProps(pOfferResults[0], i);
        delete result.shops;
        newOfferResults.push(result);
      }
      pOfferResults = newOfferResults;
      showPerShop = true;
    }

    for (const portalOfferResult of pOfferResults) {
      let showOfferResult = true;
      i += 1;

      if (pagination) {
        if (i < minOfferResultToShow || i > maxOfferResultToShow) {
          showOfferResult = false;
        }
      } else if (collapsibleResults) {
        if (i > collapsibleResultsLimit && collapsed) {
          showOfferResult = false;
        }
      }

      if (showOfferResult) {
        offerResults.push(
          <OfferResultComponent
            clientConfig={clientConfig}
            key={i}
            offerType={offerType}
            portal={portal}
            portalOfferResult={{ ...portalOfferResult }}
            rank={i}
            showPerShop={showPerShop}
            updateExperiment={updateExperiment}
            updateModal={updateModal}
            widgetOptions={widgetOptions}
          />
        );
      }
    }

    return offerResults;
  }

  collapseText() {
    const { collapsed, t } = this.props;

    if (collapsed === false) {
      return (
        <span>
          {t("collapseText")} <MaterialIcon>arrow_drop_up</MaterialIcon>
        </span>
      );
    } else {
      return (
        <span>
          {t("unCollapseText")} <MaterialIcon>arrow_drop_down</MaterialIcon>
        </span>
      );
    }
  }

  pagination() {
    const { currentPage, onPageClick, totalPages } = this.props;

    return (
      <PaginationWrapper>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageClick={onPageClick}
        />
      </PaginationWrapper>
    );
  }
}

OfferResultsLayout.propTypes = {
  collapsed: PropTypes.bool,
  currentPage: PropTypes.number,
  offerResultComponent: PropTypes.func.isRequired,
  onCollapseClick: PropTypes.func,
  onPageClick: PropTypes.func,
  totalPages: PropTypes.number
};

export default withTranslation(["offerResults"])(OfferResultsLayout);
